export const ParseApiError = (err: any) => {
  console.log(err);
  const type = getErrorType(err);
  if (type) {
    switch (type) {
      case ErrorsEnum.invalid_username:
        return $localize`Неверное имя пользователя или пароль`;
      case ErrorsEnum.invalid_password:
        return $localize`Неверное имя пользователя или пароль`;
      default:
        return $localize`Произошла ошибка` + `: ${type}`;
    }
  }
  // eslint-disable-next-line no-console
  console.warn('Cannot determine error type', type);
  return $localize`Произошла ошибка`;
};

export const ParseApiValidationError = (err: any) => {
  const errorType = getErrorType(err);
  if (errorType !== ErrorsEnum.validation_error) {
    return { type: null, target: null };
  }

  const errorDetails = err.error?.error?.details[0];
  let type: string;
  let target: string;
  if (errorDetails?.type === ServerValidationErrors.duplicate) {
    type = ServerValidationErrors.duplicate;
    target = errorDetails.target;
  } else if (errorDetails?.type === ServerValidationErrors.invalid_param) {
    type = ServerValidationErrors.invalid_param;
    target = errorDetails.target;
  } else {
    type = null;
    target = null;
  }
  return { type, target };
};

export enum ErrorsEnum {
  invalid_username = 'invalid-username',
  invalid_password = 'invalid-password',
  validation_error = 'validation-error'
}

export enum ServerValidationErrors {
  duplicate = 'duplicate',
  invalid_param = 'invalid-param',
}

export type ErrorValidationParams = {
  type: ServerValidationErrors,
  target: string,
}

function getErrorType(err: any): ErrorsEnum {
  let type;
  if (typeof err === 'string' || err instanceof String) {
    type = err;
  } else if (err?.error?.error?.type) {
    type = err.error.error.type;
  } else if (err.type) {
    type = err.type;
  } else if (err.error?.type) {
    type = err.error.type;
  }
  return type || null;
}
